import styled, { css } from 'styled-components'
import { ResponsiveSize } from 'styles/types'
import { getResponsiveStyles } from 'styles/mixins'
import { rotateSequence } from 'styles/animations'

interface LoaderImgProps {
    size?: ResponsiveSize
}

export const LoaderImg = styled.img<LoaderImgProps>`
    animation: ${rotateSequence} 1s linear infinite;
    ${({ size }) =>
        size
            ? getResponsiveStyles(size, 'width')
            : css`
                  width: 26px;
              `};
    ${({ size }) =>
        size
            ? getResponsiveStyles(size, 'height')
            : css`
                  height: 26px;
              `};
`
